<template>
  <div class="form">


    <div class="header">
      As part of our compliance with California labor laws and company policy, we require all employees to confirm their daily clock-in and clock-out times. This acknowledgment ensures accurate timekeeping and payroll processing.
    </div>
    <ol class="questions" v-if="questionsanswers != null && questionsanswers.length > 0">
      <li class="question">
        <div class="q">{{questionsanswers[0].question}}</div><br/>
        <div class="a" :class="{error: questionsanswers[0].error != null}">
          <input type="radio" name="" v-model="questionsanswers[0].answer" :disabled = "readOnly" value="yes">Yes
          <input type="radio" name="" v-model="questionsanswers[0].answer" :disabled = "readOnly" value="no">No
        </div>
        <br/>
        <div class="q" style="display:inline;" :class="{error: questionsanswers[1].error != null}">{{questionsanswers[1].question}}</div><div class="a" style="display:inline-block;">
          <input type="text" v-model="questionsanswers[1].answer" :disabled = "readOnly">
        </div>
      </li>
      <li class="question">
        <div class="q">{{questionsanswers[2].question}}</div><br/>
        <div class="a" :class="{error: questionsanswers[2].error != null}">
          <input type="radio" name="" v-model="questionsanswers[2].answer" :disabled = "readOnly" value="yes">Yes
          <input type="radio" name="" v-model="questionsanswers[2].answer" :disabled = "readOnly" value="no">No
        </div>
        <br/>
        <div class="q" style="display:inline;" :class="{error: questionsanswers[3].error != null}">{{questionsanswers[3].question}}</div><div class="a" style="display:inline-block;">
          <input type="text" v-model="questionsanswers[3].answer" :disabled = "readOnly">
        </div>
      </li>
      <li class="question">
        <div class="q">{{questionsanswers[4].question}}</div><br/>
        <div class="a" :class="{error: questionsanswers[4].error != null}">
          <input type="radio" name="" v-model="questionsanswers[4].answer" :disabled = "readOnly" value="yes">Yes
          <input type="radio" name="" v-model="questionsanswers[4].answer" :disabled = "readOnly" value="no">No
        </div>
        <br/>
        <div class="q" style="display:inline;" :class="{error: questionsanswers[5].error != null}">{{questionsanswers[5].question}}</div><div class="a" style="display:inline-block;">
          <input type="text" v-model="questionsanswers[5].answer" :disabled = "readOnly">
        </div>
      </li>
      <li class="question" >
        <div class="q">{{questionsanswers[6].question}}</div><br/>
        <div class="a" :class="{error: questionsanswers[4].error != null}">
          <input type="radio" name="" v-model="questionsanswers[6].answer" :disabled = "readOnly" value="yes">Yes
          <input type="radio" name="" v-model="questionsanswers[6].answer" :disabled = "readOnly" value="no">No
        </div>
        <br/>
        <div class="q" style="display:inline;" :class="{error: questionsanswers[7].error}">{{questionsanswers[7].question}}</div><div class="a" style="display:inline-block;" >
          <input type="text" v-model="questionsanswers[7].answer" :disabled = "readOnly">
        </div>
        <br>
        <div class="q" style="display:inline;"  :class="{error: questionsanswers[8].error}">{{questionsanswers[8].question}}</div><div class="a" style="display:inline-block;">
          <input type="text" v-model="questionsanswers[8].answer" :disabled = "readOnly" >
        </div>
      </li>
    </ol>
    <div class="footer" >
      <button class="backToMainBtn" @click="backToFormMain">Back</button>
      <button v-if="!readOnly" @click="submitSurvey">Submit</button>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'WeeklyTimeConfirmation',
    props: {
      msg: String,
      answers: Object,
      readOnly: Boolean
    },
    data() {
      return {
        questionsanswers: null,

      }
    },
    methods: {
      backToFormMain() {
        console.log ("back to main")
        this.$emit('backToSurvey', '')
      },
      submitSurvey() {
        let validForm = true
        if(this.questionsanswers[0].answer == '') {
          this.questionsanswers[0].error = true
          validForm = false;
        } else 
          this.questionsanswers[0].error = null

        if(this.questionsanswers[0].answer == 'no' && this.questionsanswers[1].answer == ''){
          this.questionsanswers[1].error = true
          validForm = false;
        } else 
          this.questionsanswers[1].error = null
        
        
        
        if(this.questionsanswers[2].answer == '') {
          this.questionsanswers[2].error = true
          validForm = false;
        }else 
          this.questionsanswers[2].error = null


        if(this.questionsanswers[2].answer == 'no' && this.questionsanswers[3].answer == ''){
          this.questionsanswers[3].error = true
          validForm = false;
        } else 
          this.questionsanswers[3].error = null




        if(this.questionsanswers[4].answer == '') {
          this.questionsanswers[4].error = true
          validForm = false;
        } else 
          this.questionsanswers[4].error = null

        if(this.questionsanswers[4].answer == 'no' && this.questionsanswers[5].answer == ''){
          this.questionsanswers[5].error = true
          validForm = false;
        } else 
        this.questionsanswers[5].error = null
        
        
        
        if(this.questionsanswers[6].answer == '') {
          this.questionsanswers[6].error = true
          validForm = false;
        } else
          this.questionsanswers[6].error = null

        if(this.questionsanswers[6].answer == 'no' && this.questionsanswers[7].answer == ''){
          this.questionsanswers[7].error = true
          validForm = false;
        } else 
          this.questionsanswers[7].error = null

        if(this.questionsanswers[6].answer == 'no' && this.questionsanswers[8].answer == ''){
          this.questionsanswers[8].error = true
          validForm = false;
        } else 
          this.questionsanswers[8].error = null

        if (!validForm)
          return false;
        else 
          this.$emit('submitSurvey', this.questionsanswers)
      }
    },
    mounted() {
      // console.log('form 1 mounted')
      // console.log(this.answers)
      if(this.answers != null && this.answers.length > 0)
        this.questionsanswers = this.answers
      else 
        this.questionsanswers = [
          {
            question: "I have had an opportunity to take an uninterrupted 30 minute meal period within 5 hours of the time I started work on each day covered by this time card, except for days when my shift was 6 hours or less, in which case I agreed to waive Brighton’s obligation to provide the opportunity to take a meal period. To the extent I did not take an uninterrupted 30 minute meal period within the first 5 hours I started the work day, (and am not covered by a meal break waiver), it was my choice to do so.",
            answer: ''
          },
          {
            question: "If you checked “No” list the day(s) you did not have an opportunity to take a timely, uninterrupted meal period and the reasons why:",
            answer: ''
          },
          {
            question: "I have been authorized and permitted to take an uninterrupted 10 minute (net) rest break for each 4 hour period (or major fraction thereof) on all shifts covered by this time card, to the extent that I did not take any rest breaks to which I was entitled, it was my own voluntary choice to do so.",
            answer: ""
          },
          {
            question: "If you checked “No” list the day(s) you did not have an opportunity to take an un-interrupted rest period and the reason why:",
            answer: ""
          },
          {
            question: "I have accurately reported all of my hours worked on my time card, including overtime hours.",
            answer: ""
          },
            {
            question: "If you checked “No” list the day(s) your time card is inaccurate and the reasons why:",
            answer: ""
          },
          {
            question: "I have no injuries or illnesses to report this week.",
            answer: ""
          }, 
          {
            question: "If you checked “No” specify the injury or illness and how it occurred:",
            answer: "", 
          },
          {
            question: "Did you report the injury to your HR Department?",
            answer: "", 
          }
        ]
    },
    unmounted() {
      // Cleanup tasks after unmounting
      console.log('Component has been unmounted');
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
  .form{
    /* max-width:800px; */
    display:block;
    position:relative;
    margin: 0 auto;
    .header{
      display:block;
      padding-bottom:30px;
    }
    ol.questions{
      padding-left:35px;
      display:block;
      li {
        padding: 0 0 30px 10px;
        .q{
          /* margin-bottom:30px; */
          display:block;
        }
        .a {
          /* margin-bottom:30px; */
          display:block;

        }
        .a.error {
          border:1px solid red;
        }
      }
    }
    .footer {
      line-height: 2;
      font-weight: bold;
      padding: 20px 0 0 0;
      text-align: center;;
      button {
        display: inline-block;
        margin: 10px 5px auto;
        padding: 0 30px;
      }
    }

  }

</style>
